"use client"

import React, {useState, useEffect} from "react";
import Image from 'next/image'
import {IoMdClose} from "react-icons/io";
import menuIc from '@/public/images/navbar/burger_menu.svg'
import styleMain from "components/Menu/styleMenu.module.scss";
import styleMenu from "components/Menu/hamburgerMenu/styleHamburgerMenu.module.scss";
import {useTekstClient} from "../../../hooks/useTekstClient";
import CountryDropdown from "../selectors/CountryDropdown";
import LanguageDropdown from "../selectors/LanguageDropdown";
import LocalizedLinkClient from "../../LocalizedLink/LocalizedLinkClient";

export default function HamburgerMenu({children}) {
    const {tekst} = useTekstClient();
    const [open, setOpen] = useState(false)

    const resolveMenuText = (value) => {
        if (typeof value !== "string") return "";
        if (!value.includes(":")) return value;
        return tekst(value);
    };

    useEffect(() => {
        if (typeof document !== "undefined") {
            document.body.style.overflow = open ? "hidden" : "";
        }
    }, [open]);

    return (
        <div className={styleMenu.hamburgerWrapper}>
            {/* Hide button when menu is open */}
            {!open && (
                <button className={`${styleMain.hamburger} ${styleMenu.hamburgerButton}`}
                        aria-label={tekst('website:menu:openHamburgerMenu')}
                        onClick={() => setOpen(o => !o)}>
                    <Image src={menuIc} alt={tekst('website:menu:openHamburgerMenu')}/>
                </button>
            )}
            <div className={`${styleMenu.overlayMenu} ${open ? styleMenu.overlayMenuShow : ''}`}>
                <div className={styleMenu.menuContainer}>
                    <button className={styleMenu.menuClose} onClick={() => setOpen(false)}
                            aria-label={tekst('website:menu:closeHamburgerMenu')}>
                        <IoMdClose className={styleMenu.closeIcon} alt={tekst('website:menu:closeHamburgerMenu')}/>
                    </button>

                    <div className={styleMenu.topSection}>
                        <LocalizedLinkClient href="/#invullen" scroll={true} style={{textDecoration: 'none'}}>
                            <button className={styleMenu.demoBtn}>{tekst('website:menu:demoButton')}</button>
                        </LocalizedLinkClient>

                        <div className={`${styleMenu.selectorWrapper} hmCompact`}>
                            <div className={styleMenu.selectorItem}>
                                <CountryDropdown/> <LanguageDropdown/>
                            </div>
                        </div>
                    </div>

                    <div className={styleMenu.menuContent}>
                        {/* Main menu items */}
                        {Object.entries(children).map(([key, data]) => {
                            const itemLabel = resolveMenuText(data.labelKey);

                            // For items with sections (Oplossingen, ProalphaMKG)
                            if (data.sections?.length) {
                                return (
                                    <div key={key} className={styleMenu.menuSection}>
                                        <h2 className={styleMenu.menuSectionTitle}>{itemLabel}</h2>

                                        {data.sections.map((section, sectionIndex) => (
                                            <div key={sectionIndex} className={styleMenu.subSection}>
                                                {section.title && (
                                                    section.titleHref ? (
                                                        <LocalizedLinkClient
                                                            href={section.titleHref}
                                                            onClick={() => setOpen(false)}
                                                            prefetch={section.titlePrefetch !== undefined ? section.titlePrefetch : true}
                                                            className={`${styleMenu.subSectionTitle} ${styleMenu.subSectionTitleLink}`}>
                                                            {resolveMenuText(section.title)}
                                                        </LocalizedLinkClient>
                                                    ) : (
                                                        <h3 className={styleMenu.subSectionTitle}>
                                                            {resolveMenuText(section.title)}
                                                        </h3>
                                                    )
                                                )}
                                                <div className={styleMenu.subSectionLinks}>
                                                    {section.links.map((link, linkIndex) => (
                                                        <LocalizedLinkClient
                                                            key={linkIndex}
                                                            href={link.href}
                                                            className={styleMenu.subSectionLink}
                                                            onClick={() => setOpen(false)}
                                                        >
                                                            {resolveMenuText(link.label)}
                                                        </LocalizedLinkClient>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                );
                            }

                            // For simple links (Support)
                            return (
                                <div key={key} className={styleMenu.menuSection}>
                                    <LocalizedLinkClient
                                        href={data.href}
                                        className={styleMenu.simpleMenuItem}
                                        onClick={() => setOpen(false)}
                                        style={{padding: '0.55rem 0 0 0'}}
                                        prefetch={data.prefetch !== undefined ? data.prefetch : true}>
                                        {itemLabel}
                                    </LocalizedLinkClient>

                                    <LocalizedLinkClient href={"/mijn-mkg/inloggen"} prefetch={false} className={styleMenu.simpleMenuItem} onClick={() => setOpen(false)}>
                                        {tekst('website:menu:myMKG')}
                                    </LocalizedLinkClient>

                                    <LocalizedLinkClient href={"/#invullen"} scroll={true} className={styleMenu.simpleMenuItem}
                                          onClick={() => setOpen(false)}>
                                        {tekst('website:menu:contact')}
                                    </LocalizedLinkClient>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}